import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {QosApiService} from '../../../services/api/settings/network-services/qos/qos-api.service';
import {NgForm} from '@angular/forms';

@Component({
  selector: 'qos',
  templateUrl: './qos.component.html',
  styleUrls: ['./qos.component.scss']
})
export class QosComponent implements OnInit {

  canSubmit: boolean;
  qosSettings = { gold: 0, silver: 0, bronze: 0 };


  constructor( private userPrivilege: UserPrivilegeService,
               private loaderService: LoaderService,
               private qosApiService: QosApiService) { }

  ngOnInit(): void {
    this.loaderService.showMainContainer();
    this.canSubmit = this.userPrivilege.isAuthorized();
    this.initialize();
  }

  submit(): void {
    this.qosApiService.editQosSettings(this.qosSettings).subscribe();
  }

  initialize(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();

    this.qosApiService.getQosSettings().subscribe(qosSettings => {
      this.qosSettings = qosSettings;
      this.loaderService.hideMainContainer();
    });
  }
}
